import type { ComponentProps } from "react";
import { forwardRef } from "react";

import { cn } from "@/lib/cn";

export const Input = forwardRef<HTMLInputElement, ComponentProps<"input">>(function Input(
  { className, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(
        "h-11 w-full rounded-full border border-input bg-muted/60 px-5 text-sm text-foreground placeholder:text-subtle-foreground outline-none transition-colors",
        "focus:border-primary/60 focus:ring-2 focus:ring-primary/30",
        "disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
});
